'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _riskByYear = require('./risk-by-year.html');

var _riskByYear2 = _interopRequireDefault(_riskByYear);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _riskByYear2.default,
  controller: function () {
    function RiskByYearComponent($scope, LoadingService, RiskByYearService, ToastService) {
      'ngInject';

      _classCallCheck(this, RiskByYearComponent);

      Object.assign(this, {
        $scope: $scope,
        LoadingService: LoadingService,
        RiskByYearService: RiskByYearService,
        ToastService: ToastService
      });
    }

    _createClass(RiskByYearComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.chartConfig = {
          chart: {
            zoomType: 'xy'
          },
          title: {
            text: 'Report Rate Per Million Administrations Sold'
          },
          subtitle: {
            text: 'NASC Adverse Event Reporting System'
          },
          xAxis: {
            type: 'datetime',
            title: {
              style: {
                fontSize: '14px'
              }
            },
            labels: {
              style: {
                fontSize: '14px'
              }
            },
            tickInterval: 12 * 30 * 24 * 3600 * 1000 // for quarterly 3 * 30 * 24 * 3600 * 1000
          },
          yAxis: [{
            title: {
              text: 'Risk (case / million)',
              style: {
                color: window.Highcharts.getOptions().colors[1],
                fontSize: '14px'
              }
            },
            labels: {
              format: '{value}',
              style: {
                color: window.Highcharts.getOptions().colors[1],
                fontSize: '14px'
              }
            }
          }, {
            title: {
              text: 'Administrations (mil)',
              style: {
                color: window.Highcharts.getOptions().colors[0],
                fontSize: '14px'
              }
            },
            labels: {
              format: '{value}',
              style: {
                color: window.Highcharts.getOptions().colors[0],
                fontSize: '14px'
              }
            },
            opposite: true
          }],
          tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:,.2f}</b></td></tr>',
            footerFormat: '</table>',
            split: true,
            useHTML: true
          },
          legend: {
            layout: 'vertical',
            align: 'left',
            x: 100,
            verticalAlign: 'top',
            y: 20,
            floating: true,
            itemWidth: 180,
            itemDistance: 0,
            itemStyle: {
              fontSize: '14px'
            }
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: false
              }
            },
            area: {
              fillOpacity: 0.2,
              lineColor: '#666666',
              lineWidth: 1,
              marker: {
                enabled: false
              }
            }
          }
        };
      }
    }, {
      key: 'generateReport',
      value: function generateReport(_ref) {
        var _this = this;

        var params = _ref.params;

        this.LoadingService.start();
        this.RiskByYearService.getReport(params).then(function (series) {
          _this.chartConfig.series = series;
        }).catch(function (error) {
          return _this.ToastService.showError(error);
        }).finally(function () {
          _this.LoadingService.stop();
          _this.$scope.$apply();
        });
      }
    }]);

    return RiskByYearComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/reports/risk-by-year/risk-by-year.component.js